import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { endOfMonth } from "date-fns";
import InputLayout from "library/Layouts/InputLayout";
import { PropTypes } from "prop-types";
import { getDateFnsLocale } from "utility/helpers/locales";
import { DatePickerView } from "../DatePicker";

const MonthPicker = ({ id, name, value, label, placeholder, onChange, helper, required }) => (
  <LocalizationProvider adapterLocale={getDateFnsLocale()} dateAdapter={AdapterDateFns}>
    <InputLayout name={name} label={label} helper={helper} required={required}>
      <DatePickerView
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        maxDate={endOfMonth(new Date())}
        views={["month", "year"]}
      />
    </InputLayout>
  </LocalizationProvider>
);

MonthPicker.defaultProps = {
  value: null,
  label: null,
  placeholder: null,
  helper: null,
  required: false,
};

MonthPicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Date),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  helper: PropTypes.node,
  required: PropTypes.bool,
};

export default MonthPicker;
